import React, { useRef, useState } from "react";
import CardTemplate from "./CardTemplate";
import styled from "styled-components";
import RedTextButton from "components/RedTextButton";
import { FinancialFormData } from "hooks/ConsultantDashboard/useConsultantDashboardData";
import { convertYMDToMDYYYY } from "utils/DateConversion";
import RegisterInvoice from "components/FinancialForm/Invoice/RegisterInvoice";
import { useReactToPrint } from "react-to-print";
import { trackConsultantDashboardInvoiceButton } from "DumbleData";

interface Props {
	financialFormData: FinancialFormData;
}

const FinancialForm = ({ financialFormData }: Props) => {
	const [printClicked, setPrintClicked] = useState(false);
	const componentRef = useRef<HTMLDivElement>(null);

	const handleClickViewInvoice = () => {
		setPrintClicked(true);
	};

	const handlePrint = () => {
		trackConsultantDashboardInvoiceButton();
		openPrintDialogue();
		setPrintClicked(false);
	};

	const openPrintDialogue = useReactToPrint({
		content: () => componentRef.current as HTMLElement,
	});

	return (
		<>
			<InvoicePDF>
				<div ref={componentRef}>
					{/* render legal copy after print button is clicked */}
					{printClicked && (
						<RegisterInvoice
							handlePrint={handlePrint}
							printClicked={printClicked}
						/>
					)}
				</div>
			</InvoicePDF>
			<CardTemplate title="Financial Form">
				<Container>
					{financialFormData.status === "NOT_YET_AVAILABLE" && (
						<InnerDiv>Not yet available</InnerDiv>
					)}
					{financialFormData.status === "SUBMITTED" && (
						<>
							<InnerDiv>
								Submitted{" "}
								{convertYMDToMDYYYY(
									financialFormData.submitted
								)}
							</InnerDiv>
							<RedTextButton handleClick={handleClickViewInvoice}>
								View Invoice
							</RedTextButton>
						</>
					)}
					{financialFormData.status === "AVAILABLE" && (
						<>
							<InnerDiv>
								Available until{" "}
								{convertYMDToMDYYYY(
									financialFormData.availableUntil
								)}
							</InnerDiv>
						</>
					)}
					{financialFormData.status === "NO_LONGER_AVAILABLE" && (
						<>
							<InnerDiv>No longer available</InnerDiv>
						</>
					)}
				</Container>
			</CardTemplate>
		</>
	);
};

const InvoicePDF = styled.div`
	display: none;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 19px;
`;

const InnerDiv = styled.div`
	font-weight: 400;
	display: inline;
`;

export default FinancialForm;
